import moment from 'moment';
import { DateRange } from '../types';
import DatePickerMixin from './DatePickerMixin';

interface Data {
  mode: string,
}

export default DatePickerMixin.extend({
  props: {
    value: Object as () => DateRange,
  },
  data(): Data {
    return {
      mode: 'range',
    };
  },
  computed: {
    humanValue(): string|null {
      if (!this.value || !this.value.start || !this.value.end) return null;
      return `${this.formatValue(this.value.start)} - ${this.formatValue(this.value.end)}`;
    },
    defaultValue(): string[] {
      if (!this.value) return [];
      return [
        this.value.start,
        this.value.end,
      ];
    },
  },
  methods: {
    setFlatpickrDate(range: DateRange|null) {
      if (!range && this.flatpickr) {
        this.flatpickr.setDate(null);
      }
      if (range && this.flatpickr) {
        this.flatpickr.setDate([
          range.start,
          range.end,
        ]);
      }
    },
    onChange(dates: string[]) {
      if (!dates.length) {
        this.$emit('input', null);
      } else if (dates.length === 2) {
        const [start, end] = dates;
        this.$emit('input', {
          start: moment(start).format('YYYY-MM-DD'),
          end: moment(end).format('YYYY-MM-DD'),
        });
      }
    },
  },
});
